import { createReducer, on } from '@ngrx/store';
import { GeoLocationState } from '../../models/states/geo-location-state.interfaces';
import * as fromGeoLocationActions from '../actions/geo-location.actions';

export const GeoLocationStateKey = 'geoLocation';

const initialState: GeoLocationState = {
  isReady: false,
  isError: false,
  geoLocationData: null,
  skipGeoLocationApi: false
};

export const geoLocationReducer = createReducer(
  initialState,
  on(
    fromGeoLocationActions.StoreGeoLocationInputValues,
    (state, { skipGeoLocationApi }) => ({
      ...state,
      skipGeoLocationApi
    })
  ),
  on(
    fromGeoLocationActions.LoadGeoLocationSuccess,
    (state, { geoLocationData }) => ({
      ...state,
      isReady: true,
      isError: false,
      geoLocationData
    })
  ),
  on(fromGeoLocationActions.LoadGeoLocationFailure, (state) => ({
    ...state,
    isReady: false,
    isError: true
  }))
);
